import { ComponentType, type IConfig } from '../../types';

export const config: IConfig = {
  component: ComponentType.CreatePage,
  configGroups: [
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
